import {
  AccountInfo,
  ProfileAccountInfoFromServer,
} from "api/interfaces/accountInterface.interface";
import { LEVEL_TYPE } from "api/interfaces/commonInterface.interface";
import {
  ResponseUserInfo,
  UserInfo,
} from "api/interfaces/userInterface.interface";
import { SUSPENSION_STATUS } from "redux/stomp/stompSubscriptionSlice";
import { checkIsSuspended } from "utils/AccountUtil";

export const getLevelFullName = (type: LEVEL_TYPE): string => {
  switch (type) {
    case LEVEL_TYPE.DW:
      return "DW Admin";
    case LEVEL_TYPE.CP:
      return "Channel Partner";
    case LEVEL_TYPE.SP:
      return "Sub Channel Partner";
    case LEVEL_TYPE.EU:
      return "End User";
    default:
      return "unknown";
  }
};

export type Account = Omit<AccountInfo, "levelFullName"> & {
  levelFullName: string;
};

export const getAccountListMappger = (data: AccountInfo[]): Account[] => {
  return Array.from(data).map((item) => {
    return {
      ...item,
      levelFullName: getLevelFullName(item.level),
    };
  });
};

export const resolveUserInfo = ({
  response,
  resolve,
  reject,
}: {
  response: UserInfo;
  resolve: (
    value:
      | ProfileAccountInfoFromServer
      | PromiseLike<ProfileAccountInfoFromServer>
  ) => void;
  reject: (reason?: any) => void;
}) => {
  if (checkIsSuspended(response.accounts) === SUSPENSION_STATUS.DISABLED) {
    reject("account suspended");
    return;
  }
  if (response.botInfo) {
    localStorage.setItem("botInfo", response.botInfo);
  }
  resolve(response.accounts);
};
